import HoverLinksPortfolio from "./HoverLinksPortfolio";
export default function Project(props) {
    return (
        <div className="projects">
            <article className="imgProject">
                <img src={props.img} alt={props.img} />
            </article>
            <HoverLinksPortfolio git={props.git} linke={props.linke} title={props.title} />
        </div>
    );
}